define('modules/page_listing/models/filter',['require','exports','module'],function (require, exports, module) {
  'use strict';
  var LIMIT_PER_PAGE = 15;

  module.exports = Backbone.Model.extend({
    initialize: function (options) {
      this._pointer = 0;
      this.limitPerPage = options.limitPerPage || this.LIMIT_PER_PAGE;
    },
    defaults: {
      from: '',
      to: '',
      name: '',
      tag: '',
      sortBy: '',
      filterBy: '',
      showHidden: false,
      totalItemCount: 0,
      disabledFilters: true,
    },
    _getAttr: function (attributes, attr) {
      return (
        attr &&
        attr.split('.').reduce(function (value, path) {
          return value && value[path];
        }, attributes)
      );
    },
    _sort: function (collection) {
      return collection;
    },
    setTriggerOrder: function (sortBy) {
      this.resetPointer();
      this.trigger('reset:order', sortBy);
    },
    setTriggerHidden: function (hidden) {
      this.showHidden = hidden;
      this.resetPointer();
      this.trigger('reset:hidden', hidden);
    },
    setTriggerPublished: function (published) {
      this.resetPointer();
      this.trigger('reset:published', published);
    },

    _loadNextChunk: function (collection) {
      if (this._pointer >= collection.length) {
        this.trigger('end:of:list');
        return collection;
      }
      const end = this._pointer + this.limitPerPage;
      var iterator = 0;
      this._pointer = end;

      const chunk = _.filter(
        collection,
        function (item) {
          iterator++;
          return iterator - 1 < end;
        },
        this
      );

      return chunk;
    },
    filterAndSort: function (collection) {
      var filterFn = _.compose(_.bind(this._sort, this)),
        filteredCollection = filterFn(collection.models || collection);

      filteredCollection = this._loadNextChunk(filteredCollection);
      return filteredCollection;
    },
    hasFiltersApplied: function () {
      return this.get('filterBy') || this.get('showHidden');
    },
    hasDisabledFilters: function () {
      return this.get('disabledFilters');
    },
    _hasSet: function (attr) {
      return this.has(attr) && this.get(attr);
    },
    isSearch: function () {
      return this._hasSet('name') || this._hasSet('tag');
    },
    querystringableAttrs: ['from', 'to', 'name', 'tag'],
    toAttributesMap: function () {
      return _.reduce(
        this.toJSON(),
        function (data, value, key) {
          if (this.querystringableAttrs.indexOf(key) > -1 && value) {
            data[key] = value;
          }
          return data;
        },
        {},
        this
      );
    },
    getTags: function () {
      var tag = this.get('tag');
      return tag ? tag.split(',') : [];
    },
    setQueryListener: function (listener, callback) {
      _.forEach(
        this.querystringableAttrs,
        function (attr) {
          listener.listenTo(this, 'change:' + attr, callback);
        },
        this
      );
    },
    resetPointer: function () {
      this._pointer = 0;
    },
  });
});

